import axios from 'axios';
import moment from 'moment';
import jwt from 'jsonwebtoken';
import qs from 'qs';
import {Auth} from '../../../utils/constants';
import {setCookie, getCookie, delay} from "../../../utils/utils";
import router from '../../../router/router';
import {mqttHandler} from '../../../mqttHandler/index';

export default {
  initialize: ({ commit, dispatch }, opt) => {
    commit('ui/SET_INITIALIZING', true, { root: true });
    dispatch('checkCookie', { ...opt, withSnapshot: true });
  },
  restartFromScratch: ({ commit, dispatch }) => {
    commit('ui/SET_OVERLAY', true, { root: true });
    dispatch('initialize', {
      callback: () => {
        commit('ui/HIDE_OVERLAY', true, { root: true });
        router.push('/');
      }
    });
  },
  fetchAccessToken: async ({ commit }, payload) => {
    commit('ui/SET_OVERLAY', true, { root: true });
    const urlFetchAccessToken = location.origin + '/auth/token';
    const tmp = Auth.clientName + ':' + Auth.clientPassword;
    const clientPassword = Buffer.from(tmp).toString('base64');
    const requestData = {
      'grant_type': 'authorization_code',
      'code': payload.code,
      'redirect_uri': ''
    };
    axios({
      method: "POST",
      url: urlFetchAccessToken,
      data: qs.stringify(requestData),
      headers: {
        'Authorization': 'Basic ' + clientPassword,
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
      }
    })
      .then(response => {
        if (response && response.data) {
          const timestamp = parseInt(moment().format('X'));
          const expiry = timestamp + parseInt(response.data['expires_in']);
          const dataToSave = { ...response.data, expiry: expiry };
          delete dataToSave['expires_in'];
          commit('SET_AUTH_DATA', dataToSave);
          setCookie(response.data.access_token);
          if (localStorage) {
            localStorage.setItem('authData', JSON.stringify(dataToSave));
          }

          if (typeof payload.callback === 'function') {
            payload.callback();
          }
        }
      })
      .catch(err => {
        commit('ui/SET_OVERLAY', false, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  checkCookie: ({ commit, getters, rootGetters, dispatch }, opt) => {
    const withSnapshot = typeof opt !== 'undefined' && typeof opt['withSnapshot'] !== 'undefined' ? opt['withSnapshot'] : false;

    const cookieValue = getCookie();
    if (cookieValue) {
      const decodedCookie = jwt.decode(cookieValue);
      if (!decodedCookie) {
        dispatch('auth/logout', null, { root: true });
        return;
      }
      if (parseInt(moment().format('X'), 10) - getters.lastCookieCheck > 30 * 60 * 60) {
        commit('ui/SET_OVERLAY', true, { root: true });
        const urlCheckToken = location.origin + '/auth/validate';

        const requestData = {
          token: cookieValue
        };

        const tmp = Auth.clientName + ':' + Auth.clientPassword;
        const clientPassword = Buffer.from(tmp).toString('base64');

        axios({
          method: "POST",
          url: urlCheckToken,
          data: qs.stringify(requestData),
          headers: {
            'Authorization': 'Basic ' + clientPassword,
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
          }
        })
          .then((response) => {
            commit('SET_AUTH_DATA', response.data.authData);
            commit('ui/RESET_BACKEND_ERROR', 0, { root: true });
            if (localStorage) {
              localStorage.setItem('authData', JSON.stringify(response.data.authData));
            }

            const protocolToUse = location.protocol === "http:" ? "ws://" : "wss://";
            const portToUse = location.protocol === "http:" ? 8083 : response.data.mqttExposedPort;
            let mqttUrl = protocolToUse + location.hostname + ':' + portToUse + '/mqtt';
            try {
              if (process.env.NODE_ENV === 'development') {
                mqttUrl = response.data.engineBrokerUrl;
              }
            } catch (e) {
              /* eslint-disable */
              console.log(e);
            }
            if (process.env.NODE_ENV === "development") {
              console.log("mqtt credentials:", mqttUrl, response.data.username, response.data.mqttPassword);
            }

            const usageId = `webui_${response.data.username}_${rootGetters['ui/clientFingerprint']}`;
            commit('ui/SET_USAGE_ID', usageId, { root: true });

            commit('mqtt/SET_TOPIC_FAMILIES', response.data.mqttTopics, { root: true });
            commit('mqtt/SET_COMMAND_TOPIC', response.data.commandTopic, { root: true });

            mqttHandler({
              url: mqttUrl,
              username: response.data.username,
              password: response.data.mqttPassword,
              topics: response.data.mqttTopics,
              usageId: usageId,
              onConnect: () => {
                commit('mqtt/SET_MQTT_CONNECTED', true, { root: true });
              },
              onClose: () => {
                commit('mqtt/SET_MQTT_CONNECTED', false, { root: true });
              },
              onRetainMessage: (topic, msg) => {
                commit('mqtt/SET_ITEM', { topic: topic, message: msg }, { root: true });
              },
              onMessage: (topic, msg) => {
                if (topic.match(/feedback/g)) {
                  commit('mqtt/APPEND_FEEDBACK_TO_HISTORY', { topic: topic, message: msg }, { root: true });
                } else {
                  commit('mqtt/SET_ITEM', { topic: topic, message: msg }, { root: true });
                }
              }
            }).catch(err => {
              /* eslint-disable */
              console.log(err);
            });

            if (withSnapshot) {
              dispatch('fetchSnapshot', opt);
            } else {
              commit('ui/SET_OVERLAY', false, { root: true });
            }

            commit('SET_LAST_COOKIE_CHECK', parseInt(moment().format('X'), 10));
          })
          .catch(err => {
            /* eslint-disable */
            console.log(err);
            if (err.response && err.response.status >= 500) {
              commit('ui/SET_BACKEND_ERROR', err.response.status, { root: true });
            } else if (err.response && err.response.status >= 400) {
              dispatch('auth/logout', null, { root: true });
            }
            commit('ui/SET_OVERLAY', false, { root: true });
          });
      } else {
        if (localStorage) {
          const strAuthData = localStorage.getItem('authData');
          if (strAuthData) {
            try {
              commit('SET_AUTH_DATA', JSON.parse(strAuthData));
              if (withSnapshot) {
                dispatch('fetchSnapshot', opt);
              }
            } catch (e) {
              /* eslint-disable */
              console.log(e);
            }
          }
        }
      }
    } else {
      location.href = location.origin + '/api/auth/authenticate?client_id=' + Auth.clientId + '&state=authorize&redirect_uri=' + location.origin + '/authenticated';
    }
  },
  fetchSnapshot: ({ commit, getters }, opt) => {
    const callback = typeof opt !== 'undefined' && typeof opt['callback'] === 'function' ? opt['callback'] : undefined;

    axios.get('/engine/snapshot', {})
      .then((response) => {
        if (response && response.data) {
          const s = response.data;
          commit('SET_USER_DATA', s['user']);
          commit('rooms/SET_FLOORS', s['floors'], { root: true });
          commit('rooms/SET_ROOMS', s['rooms'], { root: true });
          commit('devices/SET_DEVICES', s['devices'], { root: true });
          commit('devices/SET_ROAMING_DEVICES', s['roamingDevices'], { root: true });
          commit('devices/SET_DEVICE_TYPES', s['deviceTypes'], { root: true });
          commit('devices/SET_DEVICE_TOPICS', s['deviceTopics'], { root: true });
          commit('devices/SET_DEVICE_ENDPOINTS', s['deviceEndpoints'], { root: true });
          commit('devices/SET_MANUFACTURERS', s['manufacturers'], { root: true });
          commit('devices/SET_NETWORK_TYPES', s['allowedNetworkTypes'], { root: true });
          commit('objects/SET_GROUPS', s['groups'], { root: true });
          commit('objects/SET_BOARDS', s['boards'], { root: true });
          commit('objects/SET_OBJECT_TYPES', s['objectTypes'], { root: true });
          commit('objects/SET_OBJECTS', s['objects'], { root: true });
          commit('objects/SET_COMBINE_FUNCTIONS', s['allowedCombineFunctions'], { root: true });
          commit('objects/SET_ADJUSTMENT_FUNCTIONS', s['allowedAdjustmentFunctions'], { root: true });
          commit('automations/SET_AUTOMATIONS', s['automations'], { root: true });
          commit('automations/SET_EVENT_EVALUATION_TEMPLATES', s['eventEvaluationTemplates'], { root: true });
          commit('automations/SET_CONDITION_OPERATORS', s['conditionOperators'], { root: true });
          commit('automations/SET_SCHEDULE_REPEAT_TEMPLATES', s['scheduleRepeatTemplates'], { root: true });
          commit('triggers/SET_TRIGGERS', s['triggers'], { root: true });
          commit('schedules/SET_SCHEDULES', s['schedules'], { root: true });
          commit('integrations/SET_INTEGRATIONS', s['integrations'], { root: true });
          commit('integrations/SET_DISCOVERED_DEVICES', s['discoveredDevices'], { root: true });
          commit('cameras/SET_CAMERAS', s['cameras'], { root: true });
          commit('auth/SET_DUMP_FILES', s['dumpFiles'], { root: true });
          commit('auth/SET_FLAGS', s['flags'], { root: true });
          commit('events/SET_TIME_FRAMES', s['timeFrames'], { root: true });
          commit('graphs/SET_GRAPH_TEMPLATES', s['graphTemplates'], { root: true });
          commit('mqtt/SET_LOCAL_ACCESS', s['mqttLocalAccess'], { root: true });
          commit('events/SET_COMMAND_LOG', s['commandLog'], { root: true });
          commit('notifications/SET_NOTIFICATION_HANDLERS', s['notificationHandlers'], { root: true });
          commit('notifications/SET_NOTIFICATION_CHANNELS', s['notificationChannels'], { root: true });
          commit('log/SET_AUTOMATIONS_LOG_TIME_FRAMES', s['automationsLogTimeFrames'], { root: true });
          commit('log/SET_AUTOMATION_LOG_TIMESTAMP_START', s['automationLogTimestampStart'], { root: true });
          commit('requester/SET_ALLOWED_METHODS', s['requesterAllowedMethods'], { root: true });
          commit('requester/SET_COLLECTIONS', s['requesterCollections'], { root: true });
          commit('twofactor/SET_ACCOUNTS', s['twofactor']['accounts'], {root: true});
          commit('auth/SET_USER_LIST', s['userList'], { root: true });
          commit('mqtt/SET_INITIAL_FEEDBACK_HISTORY', s['loggerQueue'], { root: true });
          commit('ui/SET_GOOGLE_MAPS_API_KEY', s['addons']['googleMapsApiKey'], { root: true });
          commit('ui/SET_APP_VERSION', s['versions']['app'], { root: true });
          commit('ui/SET_ENGINE_VERSION', s['versions']['engine'], { root: true });
          commit('ui/SET_SYSTEM_INFO', s['system'], { root: true });
          if (typeof s['automationsLogTimeFrames'] !== "undefined" && s['automationsLogTimeFrames'].length > 0) {
            commit('log/SET_AUTOMATIONS_LOG_FILTER_TIME_FRAME_TAG', s['automationsLogTimeFrames'][0]['tag'], { root: true });
          }
          /* eslint-disable */
          console.log(s);

          if (getters['ui/initializing']) {
            commit('ui/SET_INITIALIZING', false, { root: true });
          }

          if (typeof callback === 'function') {
            callback();
          }
        }
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  postBackup: ({ commit }) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/backup',
      method: 'POST'
    })
      .then(() => {
        commit('ui/HIDE_OVERLAY', false, { root: true });
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  postBackupEventsData: ({ commit }) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/backup/data/events',
      method: 'POST'
    })
      .then(() => {
        commit('ui/HIDE_OVERLAY', false, { root: true });
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  postRestore: ({ commit }, params) => {
    const fileName = params['fileName'];
    const cb = typeof params['cb'] === "function" ? params['cb'] : undefined;
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/restore',
      method: 'POST',
      data: qs.stringify({ file: fileName }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
      }
    })
      .then(() => {
        commit('ui/HIDE_OVERLAY', false, { root: true });
        if (typeof cb === "function") {
          try {
            cb();
          } catch (e) {

          }
        }
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', false, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  deleteBackup: ({ commit }, encodedFileName) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/backup/' + encodedFileName,
      method: 'DELETE'
    })
      .then((response) => {
        commit('auth/DELETE_BACKUP', response.data.file, { root: true });
        commit('ui/HIDE_OVERLAY', false, { root: true });
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', false, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  downloadBackup: ({ commit }, encodedFileName) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/backup/' + encodedFileName,
    })
      .then((response) => {
        console.log(response.data);
        commit('ui/HIDE_OVERLAY', false, { root: true });
      })
      .catch(err => {
        commit('ui/HIDE_OVERLAY', false, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  },
  postRestart: ({ commit, dispatch }) => {
    commit('SET_RESTARTING', true);
    commit('mqtt/RESET_MAPPING', true, { root: true });
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/restart',
      method: 'POST'
    })
      .then((response) => {
        delay(response.data.delay)
          .then(() => {
            commit('SET_RESTARTING', false);
            commit('ui/HIDE_OVERLAY', false, { root: true });
            dispatch('initialize', {
              callback: () => {
                commit('ui/HIDE_OVERLAY', true, { root: true });
                router.push('/');
              }
            });
          });
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  postReset: ({ commit, dispatch }) => {
    commit('SET_RESTARTING', true);
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: '/engine/reset',
      method: 'POST'
    })
      .then((response) => {
        delay(response.data.delay)
          .then(() => {
            commit('SET_RESTARTING', false);
            commit('ui/HIDE_OVERLAY', false, { root: true });
            dispatch('initialize', {
              callback: () => {
                commit('ui/HIDE_OVERLAY', true, { root: true });
                router.push('/');
              }
            });
          });
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });
  },
  logout: ({ commit }) => {
    commit('ui/SHOW_OVERLAY', true, { root: true });

    const tmp = Auth.clientName + ':' + Auth.clientPassword;
    const clientPassword = Buffer.from(tmp).toString('base64');

    axios({
      url: '/auth/logout',
      method: "POST",
      headers: {
        'Authorization': 'Basic ' + clientPassword
      }
    })
      .then((response) => {
        /* eslint-disable */
        console.log(response.data);
      })
      .catch(err => {
        /* eslint-disable */
        console.log(err);
      });

    delay(600)
      .then(() => {
        if (localStorage) {
          localStorage.removeItem('authData');
        }
        document.cookie.split(";").forEach(function (c) {
          document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        commit('SET_AUTH_DATA', null);
        commit('SET_USER_DATA', null);
        commit('ui/HIDE_OVERLAY', true, { root: true });

        delay(400)
          .then(() => {
            router.push('/');
          })
      });
  },
  updateUserPresenceDetectorDevices({ commit }, { userId, list, cb }) {
    commit('ui/SHOW_OVERLAY', true, { root: true });
    axios({
      url: `/engine/users/${userId}/pds`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      data: JSON.stringify(list)
    })
      .then((response) => {
        commit('auth/SET_USER_PDS', { userId: userId, list: response.data }, { root: true });
        if (typeof cb === "function") {
          cb(null, response.data);
        }
        commit('ui/HIDE_OVERLAY', false, { root: true });
      })
      .catch(err => {
        if (typeof cb === "function") {
          cb(err);
        }
        commit('ui/HIDE_OVERLAY', false, { root: true });
        /* eslint-disable */
        console.log(err);
      });
  }
}
